import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'
import { firebaseConfig } from './firebase.config'

import { initialiseFunctions } from '../lib/api/functions/functions'

export const Firebase = initializeApp(firebaseConfig)

export const auth = getAuth()
export const db = getFirestore(Firebase)
export const storage = getStorage(Firebase)
export const functions = getFunctions(Firebase, 'europe-west2')

initialiseFunctions(functions)

export const Providers = { google: new GoogleAuthProvider() }
